// extracted by mini-css-extract-plugin
export var dropdownContainer = "_5l-5";
export var imageContainer = "_5l-4";
export var metricsGrid = "_5l-2";
export var productDetailContainer = "_5l-1";
export var productListContainer = "_5l-0";
export var subscriberTableContainer = "_5l-3";